import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import { Button, Typography } from "@material-ui/core";
import EditEmailModal from "./EditEmailModal";
import EditPwdModal from "./EditPwdModal";
import useStyles from "./styles";

const Settings = () => {
  const classes = useStyles();
  const email = localStorage.getItem("userEmail") || "";
  const [tab, setTab] = useState(2);

  const handleTabChange = (index: number) => {
    setTab(index);
  };

  return (
    <div className={classes.settingsContainer}>
      <div className={classes.sectionMenu}>
        <Button
          className={tab === 0 ? classes.menuTextActive : classes.menuText}
          onClick={() => handleTabChange(0)}
        >
          General
        </Button>
        <Button
          className={tab === 1 ? classes.menuTextActive : classes.menuText}
          onClick={() => handleTabChange(1)}
        >
          Notifications
        </Button>
        <Button
          className={tab === 2 ? classes.menuTextActive : classes.menuText}
          onClick={() => handleTabChange(2)}
        >
          Security
        </Button>
      </div>
      <div className={classes.sectionDivider} />
      <div className={classes.sectionContent}>
        <Typography className={classes.contentTitle}>
          Password & Email
        </Typography>
        <div className={classes.contentItem}>
          <Typography className={classes.contentSubTitle}>
            Your email
          </Typography>
          <div className={classes.emailRow}>
            <input
              type="text"
              value={email}
              readOnly
              className={classes.input}
            />
            {/* <EditEmailModal more={false} /> */}
          </div>
        </div>
        <div className={classes.contentItem}>
          <Typography className={classes.contentSubTitle}>
            Your password
          </Typography>
          <div className={classes.emailRow}>
            <input
              type="text"
              value={"**********"}
              readOnly
              className={classes.input}
            />
            <EditPwdModal more={false} />
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Settings;
